import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

function Counter({ value, onChange, max, testid, label }) {
  return (
    <div className="flex-1">
      <div className="text-xs text-zinc-500 truncate mb-1 text-center">{label}</div>
      <div className="flex items-center gap-2">
        <button data-testid={`${testid}-minus`} onClick={() => onChange(Math.max(0, value - 1))} className="tap-target-xl w-14 bg-zinc-100 rounded-md text-2xl font-bold">-</button>
        <input data-testid={`${testid}-input`} type="number" min={0} max={max} value={value} onChange={(e) => onChange(Math.max(0, Math.min(max, parseInt(e.target.value || 0))))} className="flex-1 h-16 text-center font-mono text-4xl bg-white border border-zinc-200 rounded-md" />
        <button data-testid={`${testid}-plus`} onClick={() => onChange(Math.min(max, value + 1))} className="tap-target-xl w-14 bg-black text-white rounded-md text-2xl font-bold">+</button>
      </div>
    </div>
  );
}

/** Dialog punteggio riusabile per girone ed ED. onSave({score_a, score_b}) / onReset() */
export function ScoreDialog({ open, onOpenChange, nameA, nameB, hits, bout, onSave, onReset }) {
  const [a, setA] = useState(0);
  const [b, setB] = useState(0);
  const [winner, setWinner] = useState(null);
  useEffect(() => {
    if (open) {
      const done = bout?.status === "completed";
      setA(done ? bout.score_for : 0); setB(done ? bout.score_against : 0);
      setWinner(done && bout.score_for === bout.score_against ? (bout.result === "V" ? "a" : bout.result === "D" ? "b" : null) : null);
    }
  }, [open, bout]);
  const tie = a === b;
  const canSave = !tie || !!winner;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="score-dialog" className="max-w-md">
        <DialogHeader><DialogTitle>Risultato · {hits} stoccate</DialogTitle><DialogDescription>Inserisci le stoccate di ciascun contendente.</DialogDescription></DialogHeader>
        <div className="flex items-end gap-3">
          <Counter value={a} onChange={setA} max={hits} testid="score-a" label={nameA} />
          <div className="pb-5 text-zinc-400 font-mono text-xl">:</div>
          <Counter value={b} onChange={setB} max={hits} testid="score-b" label={nameB} />
        </div>
        <div className="flex gap-2 mt-1">
          <button data-testid="score-quick-a" onClick={() => setA(hits)} className="flex-1 text-xs py-2 rounded border border-zinc-300 hover:bg-zinc-50">{hits} a {nameA.split(" ")[0]}</button>
          <button data-testid="score-quick-b" onClick={() => setB(hits)} className="flex-1 text-xs py-2 rounded border border-zinc-300 hover:bg-zinc-50">{hits} a {nameB.split(" ")[0]}</button>
        </div>
        {tie && (
          <div className="rounded border border-amber-200 bg-amber-50 p-3 space-y-2" data-testid="score-tie">
            <div className="text-xs text-amber-800">Parità di stoccate (es. tempo scaduto / priorità): indica chi ha vinto.</div>
            <div className="flex gap-2">
              <button data-testid="score-winner-a" onClick={() => setWinner("a")} className={`flex-1 text-sm py-2 rounded border ${winner === "a" ? "bg-black text-white border-black" : "border-zinc-300 bg-white"}`}>V {a} · {nameA.split(" ")[0]}</button>
              <button data-testid="score-winner-b" onClick={() => setWinner("b")} className={`flex-1 text-sm py-2 rounded border ${winner === "b" ? "bg-black text-white border-black" : "border-zinc-300 bg-white"}`}>V {b} · {nameB.split(" ")[0]}</button>
            </div>
          </div>
        )}
        <DialogFooter className="gap-2">
          {bout?.status === "completed" && <Button variant="outline" data-testid="score-reset" onClick={onReset}>Annulla risultato</Button>}
          <Button data-testid="score-save" disabled={!canSave} onClick={() => onSave({ score_a: a, score_b: b, winner: tie ? winner : null })} className="bg-black hover:bg-zinc-800">Salva</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
